const FALLBACK_MIME = 'application/octet-stream';

function startsWithBytes(bytes: Uint8Array, signature: number[]): boolean {
  return bytes.length >= signature.length && signature.every((value, index) => bytes[index] === value);
}

function asciiAt(bytes: Uint8Array, offset: number, length: number): string {
  if (bytes.length < offset + length) return '';
  return String.fromCharCode(...bytes.subarray(offset, offset + length));
}

/** 按文件魔数识别媒体类型；无法识别时保留调用方声明的类型。 */
export function sniffMediaContentType(bytes: Uint8Array, fallback?: string | null): string {
  if (startsWithBytes(bytes, [0xff, 0xd8, 0xff])) return 'image/jpeg';
  if (startsWithBytes(bytes, [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a])) return 'image/png';
  if (asciiAt(bytes, 0, 6) === 'GIF87a' || asciiAt(bytes, 0, 6) === 'GIF89a') return 'image/gif';
  if (asciiAt(bytes, 0, 4) === 'RIFF' && asciiAt(bytes, 8, 4) === 'WEBP') return 'image/webp';
  if (asciiAt(bytes, 0, 4) === 'RIFF' && asciiAt(bytes, 8, 4) === 'WAVE') return 'audio/wav';
  if (asciiAt(bytes, 4, 4) === 'ftyp') {
    return asciiAt(bytes, 8, 2) === 'qt' ? 'video/quicktime' : 'video/mp4';
  }
  if (asciiAt(bytes, 0, 3) === 'ID3' || startsWithBytes(bytes, [0xff, 0xfb])) return 'audio/mpeg';
  return fallback || FALLBACK_MIME;
}

/** 浏览器直传前只读取文件头，避免扩展名或浏览器 MIME 声明与实际内容不一致。 */
export async function sniffBlobContentType(blob: Blob, fallback?: string | null): Promise<string> {
  const bytes = new Uint8Array(await blob.slice(0, 32).arrayBuffer());
  return sniffMediaContentType(bytes, fallback);
}
